import { Badge } from '@/components/ui/badge';
import { Card, CardHeader } from '@/components/ui/card';
import { Env } from '@/lib/Env';
import { formatDate } from '@/lib/utils';
import { MapPin } from 'lucide-react';
import Image from 'next/image';
interface BatchCardProps {
  title: string;
  bannerImage: string;
  endDate: string;
  location: string;
  batch: number;
  status: 'Pending' | 'Active' | 'Expired';
  subjects?: string[];
}
const StatusColorMap = {
  Pending: 'bg-yellow-500 text-white',
  Active: 'bg-green-100 text-green-700',
  Expired: 'bg-x-negative-base text-white'
};
export default function BatchCard({
  title,
  bannerImage,
  endDate,
  location,
  batch,
  status
}: BatchCardProps) {
  // Calculate days remaining
  const daysRemaining = Math.ceil((new Date(endDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
  const formattedEndDate = formatDate(endDate);
  return <Card className="w-full overflow-hidden" data-sentry-element="Card" data-sentry-component="BatchCard" data-sentry-source-file="purchased-batch-card.tsx">
      <div className="gap-2 px-3 py-2 md:flex md:items-center md:justify-center">
        {/* Banner Image */}
        <div className="relative aspect-video items-center justify-center overflow-hidden rounded border md:h-24 md:w-40 ">
          <Image width={288} height={162} src={`${Env.NEXT_PUBLIC_STATIC_BUCKET_URL}/${bannerImage}`} alt={title} className="h-auto w-full md:h-full md:object-contain " data-sentry-element="Image" data-sentry-source-file="purchased-batch-card.tsx" />
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col items-start justify-center gap-1.5 self-stretch">
          <CardHeader className="space-y-2 p-0" data-sentry-element="CardHeader" data-sentry-source-file="purchased-batch-card.tsx">
            <div className="flex flex-col gap-2 md:items-center md:justify-between">
              <div>
                <h2 className="mt-2 text-lg font-semibold md:mt-0">{title}</h2>
                <p className="text-xs text-muted-foreground">
                  Ends in
                  {' '}
                  {daysRemaining}
                  {' '}
                  days (
                  {formattedEndDate}
                  )
                </p>
              </div>
              <div className="flex w-full items-center justify-start gap-2 text-sm">
                <Badge variant="default" className={`rounded ${StatusColorMap[status]} shadow-sm`} data-sentry-element="Badge" data-sentry-source-file="purchased-batch-card.tsx">
                  {status}
                </Badge>
                <div className="flex items-center gap-1">
                  <span className="text-x-secondary-text-light">•</span>
                  {location ? <>
                          <MapPin className=" size-3 border-0 text-x-secondary-text-light" />
                          <span>{location}</span>
                        </> : <span className="rounded bg-gray-100 px-1.5 py-0.5 text-xs text-muted-foreground">Online</span>}
                </div>
                <span className="text-x-secondary-text-light">•</span>
                <span className="w-full truncate">
                  Batch
                  {batch}
                </span>
              </div>
            </div>

          </CardHeader>
        </div>
      </div>
    </Card>;
}